import { IProtectedScreenValidation } from "../interfaces/IProtectedScreenValidation";

const pick = (source: any, ...keys: string[]) =>
  keys.map((key) => source?.[key]).find((value) => value !== undefined && value !== null);

/**
 * Detecta a reprovação por tela protegida dentro do envelope { success, msg, protectedScreenBlocked, protectedScreenValidation }.
 * Tolera PascalCase (ASP.NET serializa em camelCase por padrão, mas o discriminador é conferido
 * nos dois formatos por segurança). Devolve null quando a resposta é outro tipo de erro.
 */
export function extractProtectedScreenRejection(response: any): IProtectedScreenValidation | null {
  const blocked = pick(response, "protectedScreenBlocked", "ProtectedScreenBlocked");
  if (blocked !== true) return null;

  const raw = pick(response, "protectedScreenValidation", "ProtectedScreenValidation");
  if (!raw || typeof raw !== "object") return null;

  const criteria = pick(raw, "criteria", "Criteria");
  const missingItems = pick(raw, "missingItems", "MissingItems");

  return {
    evaluated: Boolean(pick(raw, "evaluated", "Evaluated") ?? true),
    isProtected: Boolean(pick(raw, "isProtected", "IsProtected") ?? true),
    screenName: String(pick(raw, "screenName", "ScreenName") ?? ""),
    confidence: Number(pick(raw, "confidence", "Confidence") ?? 0),
    score: Number(pick(raw, "score", "Score") ?? 0),
    minimumScore: Number(pick(raw, "minimumScore", "MinimumScore") ?? 7),
    maxScore: Number(pick(raw, "maxScore", "MaxScore") ?? 10),
    analysis: String(pick(raw, "analysis", "Analysis") ?? pick(response, "msg", "Msg") ?? ""),
    missingItems: Array.isArray(missingItems) ? missingItems.map(String) : [],
    criteria: Array.isArray(criteria)
      ? criteria.map((c: any) => ({
          id: String(pick(c, "id", "Id") ?? ""),
          label: String(pick(c, "label", "Label") ?? ""),
          points: Number(pick(c, "points", "Points") ?? 0),
          justification: String(pick(c, "justification", "Justification") ?? ""),
        }))
      : [],
    reportType: pick(raw, "reportType", "ReportType"),
    skipReason: pick(raw, "skipReason", "SkipReason"),
    shouldBlock: Boolean(pick(raw, "shouldBlock", "ShouldBlock") ?? true),
  };
}
